document.addEventListener("DOMContentLoaded", function () {
  const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  productForms.forEach((form) => {
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`,
    );
    if (quantityInputs.length === 0) return;
    form.addEventListener("submit", function (e) {
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;
      form.querySelectorAll('input[type="hidden"][name="quantity"]').forEach((input) => {
        input.remove();
      });
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;
      form.appendChild(qtyInput);
    });
  });

  function initFaqAccordions() {
    const faqContainers = document.querySelectorAll(".product-faq");
    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;
      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion = innerFaqContainer && innerFaqContainer.getAttribute("data-accordion") === "true";
      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");
          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }
            item.classList.toggle("active");
          });
        }
      });
    });
  }
  initFaqAccordions();
  const readMoreLinks = document.querySelectorAll(".shop-read-more");
  const readLessLinks = document.querySelectorAll(".shop-read-less");
  readMoreLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".shop-product-description");
      parent.querySelector(".shop-truncated-description").style.display = "none";
      parent.querySelector(".shop-full-description").style.display = "block";
    });
  });
  readLessLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".shop-product-description");
      parent.querySelector(".shop-truncated-description").style.display = "block";
      parent.querySelector(".shop-full-description").style.display = "none";
    });
  });
});


(function () {
  function getVisibleGalleryItems(gallery) {
    var media = Array.prototype.slice.call(gallery.querySelectorAll('.shop-image-container > .shop-image-zoom-wrapper, .shop-image-container > .shop-main-image')).filter(function (item) {
      return window.getComputedStyle(item).display !== 'none';
    });
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.shop-thumbnail')).filter(function (item) {
      return window.getComputedStyle(item).display !== 'none';
    });
    return { media: media, thumbs: thumbs };
  }

  function activateVisibleThumbnail(thumbnail) {
    var gallery = thumbnail.closest && thumbnail.closest('.product-gallery');
    if (!gallery) return;
    var items = getVisibleGalleryItems(gallery);
    var visibleIndex = items.thumbs.indexOf(thumbnail);
    if (visibleIndex < 0 || !items.media[visibleIndex]) return;

    items.media.forEach(function (media, index) {
      var active = index === visibleIndex;
      media.classList.toggle('active', active);
      var image = media.querySelector('img.shop-main-image');
      if (image) image.classList.toggle('active', active);
    });
    items.thumbs.forEach(function (thumb, index) {
      thumb.classList.toggle('active', index === visibleIndex);
    });

    var scroller = gallery.querySelector('.shop-image-container');
    var target = items.media[visibleIndex];
    if (scroller && target && typeof scroller.scrollTo === 'function') {
      var containerLeft = scroller.getBoundingClientRect().left;
      var targetLeft = target.getBoundingClientRect().left;
      scroller.scrollTo({ left: scroller.scrollLeft + targetLeft - containerLeft, behavior: 'smooth' });
    }
  }

  function handleThumbnailEvent(event) {
    var target = event.target;
    var thumbnail = target && target.closest && target.closest('.shop-thumbnail');
    if (!thumbnail || window.getComputedStyle(thumbnail).display === 'none') return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    activateVisibleThumbnail(thumbnail);
  }

  document.addEventListener('click', handleThumbnailEvent, true);
  document.addEventListener('touchend', handleThumbnailEvent, true);
})();


(function () {
  function isColourOptionInput(input) {
    var text = [input.name, input.id, input.getAttribute('aria-label')].filter(Boolean).join(' ');
    var fieldset = input.closest('fieldset, .product-form__input, variant-selects');
    if (fieldset) text += ' ' + fieldset.textContent;
    return /colou?r/i.test(text);
  }

  function getAquaInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('input[type="radio"]')).filter(function (input) {
      return String(input.value || '').trim().toLowerCase() === 'aqua' && isColourOptionInput(input);
    });
  }

  function defaultToAquaVariant() {
    var aquaInput = getAquaInputs()[0];
    if (!aquaInput) return;

    if (!aquaInput.checked) {
      var aquaLabelBefore = aquaInput.id ? document.querySelector('label[for="' + aquaInput.id + '"]') : null;
      if (aquaLabelBefore) aquaLabelBefore.click();
      aquaInput.checked = true;
    }

    var colorFieldset = aquaInput.closest('fieldset, .product-form__input');
    if (colorFieldset) {
      var selectedValue = colorFieldset.querySelector('[data-selected-value]');
      if (selectedValue) selectedValue.textContent = 'Aqua';
      var legend = colorFieldset.querySelector('legend, .form__label');
      if (legend) {
        Array.prototype.slice.call(legend.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && /colou?r\s*:/i.test(node.textContent || '')) {
            node.textContent = node.textContent.replace(/(colou?r\s*:\s*)([^\n]*)/i, '$1Aqua');
          }
        });
      }
    }

    aquaInput.dispatchEvent(new Event('input', { bubbles: true }));
    aquaInput.dispatchEvent(new Event('change', { bubbles: true }));

    var aquaLabel = document.querySelector('label[for="' + aquaInput.id + '"]');
    if (aquaLabel) {
      aquaLabel.click();
      aquaLabel.classList.add('active', 'selected');
      aquaLabel.setAttribute('aria-current', 'true');
    }

    Array.prototype.slice.call((aquaInput.form || document).querySelectorAll('input[type="radio"]')).filter(isColourOptionInput).forEach(function (input) {
      if (input !== aquaInput) {
        var label = document.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.classList.remove('active', 'selected');
          label.removeAttribute('aria-current');
        }
      }
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(defaultToAquaVariant, 0);
      window.setTimeout(defaultToAquaVariant, 250);
      window.setTimeout(defaultToAquaVariant, 1000);
      window.setTimeout(defaultToAquaVariant, 2000);
    });
  } else {
    window.setTimeout(defaultToAquaVariant, 0);
    window.setTimeout(defaultToAquaVariant, 250);
  }

  window.addEventListener('load', function () {
    window.setTimeout(defaultToAquaVariant, 0);
    window.setTimeout(defaultToAquaVariant, 500);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(defaultToAquaVariant, 0);
    window.setTimeout(defaultToAquaVariant, 500);
  });
})();


(function () {
  function isVisible(element) {
    return !!element && window.getComputedStyle(element).display !== 'none';
  }

  function normalizeKey(value) {
    return String(value || '').replace(/s+/g, ' ').trim();
  }

  function mediaMatchesThumbnail(media, thumbnail) {
    var thumbKey = normalizeKey(thumbnail.getAttribute('data-variant-media-key'));
    var mediaKey = normalizeKey(media.getAttribute('data-variant-media-key'));
    if (thumbKey && mediaKey && thumbKey === mediaKey) return true;
    var thumbMediaId = thumbnail.getAttribute('data-media-id');
    var mediaId = media.getAttribute('data-media-id') || (media.querySelector('[data-media-id]') && media.querySelector('[data-media-id]').getAttribute('data-media-id'));
    return !!thumbMediaId && !!mediaId && thumbMediaId === mediaId;
  }

  function activateThumbnailMedia(thumbnail) {
    var gallery = thumbnail.closest && thumbnail.closest('.product-gallery');
    if (!gallery || !isVisible(thumbnail)) return;

    var allMedia = Array.prototype.slice.call(gallery.querySelectorAll('.shop-image-container > .shop-image-zoom-wrapper, .shop-image-container > .shop-main-image'));
    var allThumbs = Array.prototype.slice.call(gallery.querySelectorAll('.shop-thumbnail'));
    var target = allMedia.filter(function (media) { return isVisible(media) && mediaMatchesThumbnail(media, thumbnail); })[0];

    if (!target) {
      var visibleThumbs = allThumbs.filter(isVisible);
      var visibleMedia = allMedia.filter(isVisible);
      var visibleIndex = visibleThumbs.indexOf(thumbnail);
      target = visibleIndex >= 0 ? visibleMedia[visibleIndex] : null;
    }

    if (!target) return;

    allMedia.forEach(function (media) {
      var active = media === target;
      media.classList.toggle('active', active);
      media.setAttribute('aria-hidden', active ? 'false' : 'true');
      var image = media.querySelector('img.shop-main-image');
      if (image) image.classList.toggle('active', active);
      var video = media.querySelector('video');
      if (video) {
        if (active) video.play && video.play().catch(function () {});
        else {
          video.pause && video.pause();
          try { video.currentTime = 0; } catch (error) {}
        }
      }
    });

    allThumbs.forEach(function (thumb) {
      var active = thumb === thumbnail;
      thumb.classList.toggle('active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });

    var scroller = gallery.querySelector('.shop-image-container');
    if (scroller && typeof scroller.scrollTo === 'function') {
      var left = target.offsetLeft;
      if (!left && target.getBoundingClientRect) {
        left = scroller.scrollLeft + target.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
      }
      scroller.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  function onThumbnailPointer(event) {
    var target = event.target;
    var thumbnail = target && target.closest && target.closest('.shop-thumbnail');
    if (!thumbnail) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    activateThumbnailMedia(thumbnail);
  }

  document.addEventListener('pointerup', onThumbnailPointer, true);
  document.addEventListener('touchend', onThumbnailPointer, true);
  document.addEventListener('click', onThumbnailPointer, true);
})();


(function () {
  function hideNode(node) { if (node) node.classList.add('fresh-skin-force-hidden'); }
  function closestBlock(node) { return node ? (node.closest('[class*="block-"], .shop-product-block, .product__accordion, .product-form__input, variant-selects') || node) : null; }
  function findTextNode(root, text) {
    var needle = text.toLowerCase();
    return Array.from(root.querySelectorAll('h1, h2, h3, p, span, div, li, summary, button')).find(function (node) {
      return (node.textContent || '').trim().toLowerCase().indexOf(needle) !== -1;
    });
  }
  function setText(root, text, value) { var node = findTextNode(root, text); if (node) node.textContent = value; return node; }

  function applyFreshSkinSystemLayout() {
    var root = document.querySelector('.shop-product-info, .product__info-container, product-info');
    if (!root || root.dataset.freshSkinSystemApplied === 'true') return;
    var currentText = root.textContent || '';
    var alreadyFresh = /Fresh Skin System/i.test(currentText);
    if (!alreadyFresh) return;

    root.dataset.freshSkinSystemApplied = 'true';
    root.classList.add('fresh-skin-product-info');

    var rating = root.querySelector('.rating-text-content, .shop-product-rating-text');
    if (rating) rating.innerHTML = '<p><strong>4.9/5</strong> <span>(4,421 REVIEWS)</span></p>';
    hideNode(closestBlock(root.querySelector('.shop-product-price, .price')));
    Array.from(root.querySelectorAll('hr, .shop-product-divider, [class*="divider"]')).forEach(hideNode);
    Array.from(root.querySelectorAll('variant-selects, .product-form__input, select')).forEach(function (element) {
      if (/Size|XS|Small|Medium|Large/i.test(element.textContent || element.value || '')) hideNode(closestBlock(element));
    });

    var subtitleNode = setText(root, 'Lifts, squeezes and flows', 'Designed to help keep your sleep surface fresher.');
    if (!subtitleNode) subtitleNode = findTextNode(root, 'Designed to help keep your sleep surface');
    if (subtitleNode) subtitleNode.classList.add('fresh-skin-subtitle');

    var productBulletList = root.querySelector('.product-bullet-list');
    var benefitGrid = root.querySelector('.bg-benefits-grid');
    if (productBulletList) {
      productBulletList.classList.add('fresh-skin-product-bullets');
      if (benefitGrid) hideNode(benefitGrid);
    } else if (benefitGrid) {
      benefitGrid.classList.add('fresh-skin-benefits-grid');
      var benefitLabels = ['Reduces oil & residue build-up', 'Fresh sleep surface every night', 'Designed for sensitive skin'];
      Array.from(benefitGrid.querySelectorAll('.bg-benefit-item')).forEach(function (item, index) {
        var textNode = item.querySelector('.bg-benefit-text');
        if (benefitLabels[index]) {
          if (textNode) textNode.textContent = benefitLabels[index];
          item.classList.remove('fresh-skin-force-hidden');
          if (textNode) textNode.classList.remove('fresh-skin-force-hidden');
        } else {
          hideNode(item);
        }
      });
    } else if (!root.querySelector('.fresh-skin-benefits')) {
      var insertAfter = subtitleNode || title || rating || root.firstElementChild;
      insertAfter.insertAdjacentHTML('afterend', '<div class="fresh-skin-benefits"><p><span aria-hidden="true">⌁</span><strong>Reduces oil &amp; residue build-up</strong></p><p><span aria-hidden="true">↻</span><strong>Fresh sleep surface every night</strong></p><p><span aria-hidden="true">☺</span><strong>Designed for sensitive skin</strong></p></div>');
    }

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFreshSkinSystemLayout);
  else applyFreshSkinSystemLayout();
  document.addEventListener('shopify:section:load', applyFreshSkinSystemLayout);
  setTimeout(applyFreshSkinSystemLayout, 150);
  setTimeout(applyFreshSkinSystemLayout, 800);
}());
